<template>
  <div class="landing" ref="landing">
    <link rel="stylesheet" href="https://fonts.googleapis.com/css2?family=Nunito+Sans:ital,wght@0,300;0,400;0,600;0,700;0,800;1,700&display=swap">
    <header id="banner">
      <a href="">NAVLIN DAILY</a>
      <nav aria-label="Site">
        <ul>
          <li>
            <div class="menu-widget" id="prodDropdown" :class="{'active-within':productDropdownStatus}">
              <el-dropdown trigger="click" @visible-change="handleProductVisible">
                <button type="button" class="menu-button popup-trigger nav-dropdown-btn" :class="{'active':productDropdownStatus}">
                  <span class="text unchangeable">Products</span>
                  <svg class="sprite ico-chevron-down-sm"><use xlink:href="#ico-chevron-down-sm" /></svg>
                </button>
                <template #dropdown>
                  <el-dropdown-menu class="popup prod-dropdown">
                    <ul class="menu">
                      <li><div class="menuitem active">
                        <svg width="44" height="44" viewBox="0 0 44 44" stroke-width="0">
                          <path style="--color-static: #99A9C1; --color-hover: #004E92;" class="svg-ele" opacity="0.9" d="M16.8438 30.5938L10.3125 35.75H32.4688C35.2302 35.75 37.4688 33.5114 37.4688 30.75V25.0938L26.5362 14.1612C25.5248 13.1498 23.8094 13.4961 23.2698 14.8208L16.8438 30.5938Z"></path>
                          <path style="--color-static: #143A71; --color-hover: #4988B5;" class="svg-ele" opacity="0.55" d="M32.4688 35.75H11.2463C9.48076 35.75 8.58122 33.6293 9.80829 32.36L15.3088 26.6697C15.9943 25.9606 17.0944 25.8571 17.9002 26.4259L20.7519 28.4389C21.6377 29.0641 22.8604 28.8697 23.5086 28.0006L33.8655 14.1129C35.0162 12.5699 37.4688 13.3838 37.4688 15.3085V30.75C37.4688 33.5114 35.2302 35.75 32.4688 35.75Z"></path>
                          <path style="--color-static: #143A71; --color-hover: #4988B5;" class="svg-ele" opacity="0.55" d="M6.14394 30.9427C5.76711 31.3464 5.78893 31.9792 6.19268 32.3561C6.59643 32.7329 7.22922 32.7111 7.60606 32.3073L6.14394 30.9427ZM34.4875 8.85C34.8189 8.40817 34.7293 7.78137 34.2875 7.45C33.8457 7.11863 33.2189 7.20817 32.8875 7.65L34.4875 8.85ZM21.6514 23.1307L21.9843 22.1877L21.6514 23.1307ZM22.7843 22.7877L21.9843 22.1877L22.7843 22.7877ZM7.60606 32.3073L16.7844 22.4733L15.3223 21.1087L6.14394 30.9427L7.60606 32.3073ZM16.7844 22.4733L21.3186 24.0736L21.9843 22.1877L17.4501 20.5874L16.7844 22.4733ZM23.5843 23.3877L34.4875 8.85L32.8875 7.65L21.9843 22.1877L23.5843 23.3877ZM21.3186 24.0736C22.1426 24.3645 23.06 24.0867 23.5843 23.3877L21.9843 22.1877L21.3186 24.0736ZM16.7844 22.4733L17.4501 20.5874C16.7002 20.3227 15.8649 20.5274 15.3223 21.1087L16.7844 22.4733Z"></path>
                        </svg><a href="https://navlin.com/data.php">
                        NAVLIN Price &amp; Access Data</a></div></li>
                      <li><div class="menuitem">
                        <svg width="44" height="44" viewBox="0 0 28 28" stroke-width="0">
                          <path style="--color-static: #99A9C1; --color-hover: #004E92;" class="svg-ele" opacity="0.9" fill-rule="evenodd" clip-rule="evenodd" d="M5.25 8.67045C5.25 7.26464 6.38964 6.125 7.79545 6.125H18.4545C19.8604 6.125 21 7.26464 21 8.67045V15.8295C21 17.2354 19.8604 18.375 18.4545 18.375H7.79545C6.38964 18.375 5.25 17.2354 5.25 15.8295V8.67045ZM7.56564 8.44064C7.7365 8.26979 8.0135 8.26979 8.18436 8.44064L10.3719 10.6281C10.5427 10.799 10.5427 11.076 10.3719 11.2469L8.18436 13.4344C8.0135 13.6052 7.7365 13.6052 7.56564 13.4344C7.39479 13.2635 7.39479 12.9865 7.56564 12.8156L9.44378 10.9375L7.56564 9.05936C7.39479 8.8885 7.39479 8.6115 7.56564 8.44064ZM12.375 11.125C12.1334 11.125 11.9375 11.3209 11.9375 11.5625C11.9375 11.8041 12.1334 12 12.375 12H16.75C16.9916 12 17.1875 11.8041 17.1875 11.5625C17.1875 11.3209 16.9916 11.125 16.75 11.125H12.375Z"></path>
                          <path style="--color-static: #143A71; --color-hover: #4988B5;" class="svg-ele" opacity="0.55" fill-rule="evenodd" clip-rule="evenodd" d="M13.5 13C15.0239 13 16.3204 13.9739 16.8008 15.3333L24 15.3333L25.1666 16.5L24 17.6667L23.4166 17.6667L22.8333 17.0833L20.7549 17.0833L20.4264 17.6667L16.8008 17.6667C16.3204 19.0261 15.0239 20 13.5 20C11.567 20 10 18.433 10 16.5C10 14.567 11.567 13 13.5 13ZM13.5 16.5C13.5 15.8557 12.9777 15.3333 12.3333 15.3333C11.689 15.3333 11.1667 15.8557 11.1667 16.5C11.1667 17.1443 11.689 17.6667 12.3333 17.6667C12.9777 17.6667 13.5 17.1443 13.5 16.5Z"></path>
                        </svg><a href="https://navlin.com/software.php">
                        NAVLIN Price &amp; Access Software</a></div></li>
                      <li><div class="menuitem">
                        <svg width="44" height="44" viewBox="0 0 28 28" stroke-width="0">
                          <path style="--color-static: #99A9C1; --color-hover: #004E92;" class="svg-ele" opacity="0.9" fill-rule="evenodd" clip-rule="evenodd" d="M8.875 5.6875C8.32272 5.6875 7.875 6.13522 7.875 6.6875V21.3125C7.875 21.8648 8.32272 22.3125 8.875 22.3125H19.125C19.6773 22.3125 20.125 21.8648 20.125 21.3125V6.6875C20.125 6.13522 19.6773 5.6875 19.125 5.6875H8.875ZM9.625 16.9375C9.625 16.6959 9.82088 16.5 10.0625 16.5H17.5C17.7416 16.5 17.9375 16.6959 17.9375 16.9375C17.9375 17.1791 17.7416 17.375 17.5 17.375H10.0625C9.82088 17.375 9.625 17.1791 9.625 16.9375ZM9.625 19.125C9.625 18.8834 9.82088 18.6875 10.0625 18.6875H14.4375C14.6791 18.6875 14.875 18.8834 14.875 19.125C14.875 19.3666 14.6791 19.5625 14.4375 19.5625H10.0625C9.82088 19.5625 9.625 19.3666 9.625 19.125Z"></path>
                          <rect style="--color-static: #143A71; --color-hover: #4988B5;" class="svg-ele" opacity="0.55" x="5.25" y="7" width="10.9375" height="7" rx="1"></rect>
                        </svg><a href="https://navlin.com/insights.php">
                        NAVLIN Insights</a></div></li>
                    </ul>
                  </el-dropdown-menu>
                </template>
              </el-dropdown>
            </div>
          </li>
          <li><a href="https://www.eversana.com/insights/">Thought Leadership</a></li>
          <li><router-link to="/contactUs">Contact</router-link></li>
        </ul>
        <router-link class="button solid blue" :to="userInfo.username?'/front':'/login'">Login</router-link>
      </nav>
      <button id="btn-open-menu" type="button" aria-expanded="false"
              @click="showMobileNav = !showMobileNav" v-if="!showMobileNav"
              aria-controls="menu" hidden><svg class="sprite ico-bars"><title>Open the menu</title><use xlink:href="#ico-bars" /></svg></button>
    </header>

    <div id="menu" role="region" aria-label="Menu"
         @click="showMobileNav = !showMobileNav" v-if="showMobileNav"
         class="active">
      <button id="btn-close-menu" type="button"><svg class="sprite ico-times"><title>Close the Menu</title><use xlink:href="#ico-times" /></svg></button>
      <a href="">Navlin</a>
      <nav aria-label="Site">
        <ul>
          <li><a href="">Home</a></li>
          <li><a href="https://navlin.com/data.php">NAVLIN Price &amp; Access Data</a></li>
          <li><a href="https://navlin.com/software.php">NAVLIN Price &amp; Access Softwate</a></li>
          <li><a href="https://navlin.com/insights.php">NAVLIN Insights</a></li>
          <li><router-link to="/contactUs">Contact</router-link></li>
        </ul>
        <router-link class="button lg solid orange" :to="userInfo.username?'/front':'/login'">Login</router-link>
      </nav>
      <article aria-label="Social Links">
        <ul>
          <li><a href="https://data.navlin.com/alspc/#!/getStarted" target="_blank" rel="noopener"><svg class="sprite ico-eversana-logo-graphic"><title>Eversana</title><use xlink:href="#ico-eversana-logo-graphic" /></svg></a></li>
          <li><a href="https://www.linkedin.com/showcase/navlin-by-eversana" target="_blank" rel="noopener"><svg class="sprite ico-linkedin-in"><title>LinkedIn</title><use xlink:href="#ico-linkedin-in" /></svg></a></li>
        </ul>
      </article>
    </div>

    <main>

      <section id="hero">
        <div class="w">
          <h1>Daily News Trusted By Global Pricing &amp; Market Access Experts</h1>
          <p>Global pricing and market access news without all of the noise. NAVLIN DAILY connects the dots on how the day’s biggest stories affect your business and keeps you up-to-date and informed.</p>
          <router-link to="/subscribe" class="button lg solid blue">Subscribe Now</router-link>
          <a href="#news" class="button lg bordered white">Read Today’s News</a>
        </div>
        <img src="../../assets/img-landing/preview.jpg" srcset="../../assets/img-landing/preview.jpg 1x, ../../assets/img-landing/preview@2x.jpg 2x, ../../assets/img-landing/preview@3x.jpg 3x" width="884" height="541" alt="">
      </section>


      <div id="w-utd-incl">
        <section id="utd">
          <h1>Stay Up to Date</h1>
          <p>NAVLIN DAILY covers what you need to know to bring greater success to your organizations pricing and market access strategy. We'll help inform your team so you can make better, smarter decisions.</p>
          <ul>
            <li>Biosimilar</li>
            <li>HTA</li>
            <li>Breaking News</li>
            <li>Policy</li>
            <li>Cost Effectiveness</li>
            <li>Price Changes</li>
            <li>Drug Approval</li>
            <li>Drug Launch</li>
            <li>Drug Safety Issues</li>
            <li>Regulation</li>
            <li>European Union</li>
            <li>Editor's Choice</li>
            <li>Pricing &amp; Reimbursement</li>
            <li>Reference Pricing (IRP)</li>
            <li>Tender and more!</li>
          </ul>
        </section>
        <section id="incl">
          <h1>Every Subscription Includes</h1>
          <ul>
            <li>
              <img src="../../assets/img-landing/sprite.svg#ico-incl-news-and-noti" width="36" height="36" alt="">
              Daily News and Notifications
            </li>
            <li>
              <img src="../../assets/img-landing/sprite.svg#ico-incl-newsletter" width="36" height="36" alt="">
              Monthly Newsletter
            </li>
            <li>
              <img src="../../assets/img-landing/sprite.svg#ico-incl-hta" width="36" height="36" alt="">
              HTA Decision Summaries
            </li>
            <li>
              <img src="../../assets/img-landing/sprite.svg#ico-incl-drug" width="36" height="36" alt="">
              Drug Approvals
            </li>
            <li>
              <img src="../../assets/img-landing/sprite.svg#ico-incl-aad-hoc" width="36" height="36" alt="">
              Ad-Hoc Price Requests
            </li>
            <li>
              <img src="../../assets/img-landing/sprite.svg#ico-incl-support" width="36" height="36" alt="">
              24/5 Customer Support
            </li>
<!--            <li>-->
<!--              <img src="../../assets/img-landing/sprite.svg#ico-incl-iphone-app" width="36" height="36" alt="">-->
<!--              <span>iPhone App - <a href="" target="_blank">Download</a></span>-->
<!--            </li>-->
          </ul>
        </section>
      </div>


      <section id="news" v-loading="loading">
        <header @click="jumpToNews">
          <div id="news-location" style="position: absolute;top: -20px;left: 0;width: 100%;"></div>
          <small>NAVLIN DAILY</small>
          <h1>Read Today’s News</h1>
        </header>
        <el-empty v-if="freeArticle.length == 0 && !loading" description="No free articles yet">

        </el-empty>
        <div class="slick-slider">
          <button class="slick-arrow slick-prev" type="button" style=""><svg class="sprite ico-long-arrow-left"><title>Previous</title><use xlink:href="#ico-long-arrow-left"></use></svg></button>
          <button class="slick-arrow slick-next" type="button" style=""><svg class="sprite ico-long-arrow-right"><title>Next</title><use xlink:href="#ico-long-arrow-right"></use></svg></button>
          <swiper :modules="modules" class="w" v-if="freeArticle.length>0"
                  :space-between="30" :autoplay="false" :loop="true"
                  :pagination="{ clickable: true }"
                  :navigation="{
                    prevEl: '#news .slick-prev',
                    nextEl: '#news .slick-next'
                  }"
                  :breakpoints="{
                  0: {
                  slidesPerView: 1,
                  spaceBetween: 20,
                  centeredSlides: true,
                  },
                  768: {
                  slidesPerView: 2,
                  slidesPerGroup: 2,
                  spaceBetween: 30,
                  },
                  1024: {
                  slidesPerView: 3,
                  slidesPerGroup: 3,
                  spaceBetween: 30,
                  },
                }"
          >
            <swiper-slide v-for="(item,idx) in freeArticle" :key="idx">
              <article>
                <router-link :to="`/article/${item.id}/${item.alias}`" tabindex="-1" aria-hidden="true">
                  <img :src="item.image" alt="">
                </router-link>
                <h2><router-link :to="`/article/${item.id}/${item.alias}`">{{item.headline}}</router-link></h2>
                <p v-html="parseBrief(item.brief)"></p>
                <footer>
                  <time>{{momentTimeFormat(item)}}</time>
                  <newsItemTopics :item="item" :limit="1"></newsItemTopics>
                </footer>
              </article>
            </swiper-slide>
          </swiper>
        </div>
        <router-link to="/subscribe" class="button lg solid darkblue">Subscribe to NAVLIN DAILY</router-link>
      </section>

      <section id="cta">
        <div class="w">
          <h1>Looking for pricing and access data? <strong>Find out why customers rely on NAVLIN!</strong></h1>
          <p>Start your free trial of NAVLIN Price &amp; Access Data today!</p>
        </div>
        <a target="_blank" href="https://navlin.com/data.php" class="button lg solid blue">Learn More</a>
        <a target="_blank" href="https://data.navlin.com/alspc/#!/scheduleDemo" class="button lg solid deepblue">Book a Meeting</a>
      </section>

      <section id="testi">
        <header>
          <small>Real quotes from real clients.</small>
          <h1>Client Delight</h1>
        </header>
        <div class="w">
          <svg class="sprite ico-left-double-quotation-mark-1"><use xlink:href="#ico-left-double-quotation-mark"></use></svg>
          <svg class="sprite ico-left-double-quotation-mark-2"><use xlink:href="#ico-left-double-quotation-mark"></use></svg>
          <swiper :modules="modules" class="slick-list"
                  :space-between="30" :autoplay="false" :loop="true"
                  :pagination="{ clickable: true }"
                  effect="fade" :fadeEffect="{crossFade: true}"
                  :navigation="{
                    prevEl: '#testi .slick-prev',
                    nextEl: '#testi .slick-next'
                  }"
                  :breakpoints="{
                  1024: {
                    slidesPerView: 1,
                    slidesPerGroup: 1,
                    centeredSlides: true,
                  },
                }"
          >
            <swiper-slide>
              <figure>
                <blockquote style="font-size: 30px;">
                  <p>NAVLIN Price &amp; Access Data is an amazing tool, the data quality, insights, and user-friendliness are far superior to any other pricing database I've used in my career.</p>
                </blockquote>
                <figcaption>
                  <p>Enric Muñoz</p>
                  <p>Sr. Director, Global Strategic Pricing Head, Takeda</p>
                </figcaption>
              </figure>
            </swiper-slide>
            <swiper-slide>
              <figure>
                <blockquote style="font-size: 27px;">
                  <p>NAVLIN delivers a comprehensive and superior pricing platform offering quality and reliable data, strategic insights, and a dedicated team of individuals who are best in class - true partners in every aspect.</p>
                </blockquote>
                <figcaption>
                  <p>Vylynh Vo</p>
                  <p>Head, Global Value Strategy &amp; Policy @ Atara Biotherapeutics</p>
                </figcaption>
              </figure>
            </swiper-slide>
            <swiper-slide>
              <figure>
                <blockquote style="font-size: 37px;">
                  <p>I've been singing the praises of EVERSANA to everyone! NAVLIN Price &amp; Access Data is truly amazing!</p>
                </blockquote>
                <figcaption>
                  <p>Senior Director</p>
                  <p>Market Access</p>
                </figcaption>
              </figure>
            </swiper-slide>
            <swiper-slide>
              <figure>
                <blockquote>
                  <p>My team literally could not do what they do without NAVLIN Price &amp; Access Data.</p>
                </blockquote>
                <figcaption>
                  <p>Senior Director</p>
                  <p>Senior Director, Global Value Strategy &amp; Policy</p>
                </figcaption>
              </figure>
            </swiper-slide>
            <swiper-slide>
              <figure>
                <blockquote style="font-size: 37px;">
                  <p>To say thank you seems so trivial. I really appreciate all the hard work and time that you all have invested.</p>
                </blockquote>
                <figcaption>
                  <p>Vice President</p>
                  <p>Global Pricing &amp; Market Access</p>
                </figcaption>
              </figure>
            </swiper-slide>
            <swiper-slide>
              <figure>
                <blockquote style="font-size: 33px;">
                  <p>Your response was quicker than I have received from any other pricing data providers. I really appreciate your help at 11 PM :)</p>
                </blockquote>
                <figcaption>
                  <p>Head</p>
                  <p>Global Value Strategy &amp; Policy</p>
                </figcaption>
              </figure>
            </swiper-slide>
            <swiper-slide>
              <figure>
                <blockquote style="font-size: 33px;">
                  <p>The customer service is amazing - knowledgeable, friendly, and responsive. Every time I need assistance I am always impressed.</p>
                </blockquote>
                <figcaption>
                  <p>Information Analyst</p>
                  <p>Global Pricing &amp; Market Access</p>
                </figcaption>
              </figure>
            </swiper-slide>
            <swiper-slide>
              <figure>
                <blockquote>
                  <p>Accurate and fast response, exactly what I needed, could not ask for more.</p>
                </blockquote>
                <figcaption>
                  <p>Head</p>
                  <p>Pricing and Health Outcomes</p>
                </figcaption>
              </figure>
            </swiper-slide>
            <swiper-slide>
              <figure>
                <blockquote style="font-size: 27px;">
                  <p>I recently had the pleasure of using the NAVLIN Tender Data Service for a project. The data was spot on and saved me a lot of time, allowing me to focus on data analysis instead of data collection.</p>
                </blockquote>
                <figcaption>
                  <p>Global Marketing Director Rx</p>
                  <p>Medis, Medical Marketing Company</p>
                </figcaption>
              </figure>
            </swiper-slide>
          </swiper>
          <button class="slick-prev slick-arrow" type="button" style=""><svg class="sprite ico-long-arrow-left"><title>Previous</title><use xlink:href="#ico-long-arrow-left"></use></svg></button>
          <button class="slick-next slick-arrow" type="button" style=""><svg class="sprite ico-long-arrow-right"><title>Next</title><use xlink:href="#ico-long-arrow-right"></use></svg></button>
        </div>
      </section>

      <subscriptionSection class="subscription"></subscriptionSection>

    </main>

    <pageFooter>
    </pageFooter>

    <svg style="position: absolute;" width="0" height="0" aria-hidden="true">

      <symbol id="ico-chevron-down-sm" viewBox="0 0 8 4">
        <path transform="scale(1 -1)" transform-origin="center" d="M6.64645 3.85355C6.84171 4.04882 7.15829 4.04882 7.35355 3.85355C7.54882 3.65829 7.54882 3.34171 7.35355 3.14645L6.64645 3.85355ZM0.646447 3.14645C0.451184 3.34171 0.451184 3.65829 0.646447 3.85355C0.841709 4.04882 1.15829 4.04882 1.35355 3.85355L0.646447 3.14645ZM4 0.5L4.35355 0.146446C4.15829 -0.0488157 3.84171 -0.0488158 3.64645 0.146446L4 0.5ZM7.35355 3.14645L4.35355 0.146446L3.64645 0.853553L6.64645 3.85355L7.35355 3.14645ZM3.64645 0.146446L0.646447 3.14645L1.35355 3.85355L4.35355 0.853553L3.64645 0.146446Z" stroke-width="0" />
      </symbol>

      <symbol id="ico-bars" viewBox="0 0 22 18" stroke-width="0">
        <path d="M1 0C0.447715 -4.82823e-08 4.82823e-08 0.447715 0 1C-4.82823e-08 1.55228 0.447715 2 1 2L1 0ZM21 2C21.5523 2 22 1.55229 22 1C22 0.447717 21.5523 1.79674e-06 21 1.74846e-06L21 2ZM1 2L21 2L21 1.74846e-06L1 0L1 2Z" />
        <path d="M1 8C0.447715 8 0 8.44772 0 9C0 9.55228 0.447715 10 1 10V8ZM21 10C21.5523 10 22 9.55228 22 9C22 8.44772 21.5523 8 21 8V10ZM1 10H21V8H1V10Z" />
        <path d="M1 16C0.447715 16 0 16.4477 0 17C0 17.5523 0.447715 18 1 18V16ZM21 18C21.5523 18 22 17.5523 22 17C22 16.4477 21.5523 16 21 16V18ZM1 18H21V16H1V18Z" />
      </symbol>

      <symbol id="ico-times" viewBox="0 0 18 18" fill="none" stroke-width="2" stroke-linecap="round">
        <path d="M2 2L16.1421 16.1421" />
        <path d="M1.92871 16.071L16.0708 1.92891" />
      </symbol>

      <symbol id="ico-eversana-logo-graphic" viewBox="0 0 27 25" stroke-width="0">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M12.5133 24.993L9.51067 19.4549H8.35579L10.7076 23.7924H9.5443L7.19217 19.4549H6.03729L8.38941 23.7924H7.22612L4.874 19.4549H3.71912L6.72207 24.993H12.5133Z" />
        <path fill-rule="evenodd" clip-rule="evenodd" d="M23.142 19.743L17.0262 19.7466L16.4597 20.7929L21.2497 20.7903L20.6793 21.8439L15.889 21.8469L15.3226 22.8928L20.1129 22.8902L19.5422 23.9441L14.7519 23.9468L14.1855 24.993L20.3014 24.9894L23.142 19.743Z" />
        <path fill-rule="evenodd" clip-rule="evenodd" d="M14.5272 0.662109L17.5298 6.20065H18.6847L16.3326 1.86244H17.4962L19.848 6.20065H21.0029L18.6511 1.86244H19.8144L22.1662 6.20065H23.321L20.3187 0.662109H14.5272Z" />
        <path fill-rule="evenodd" clip-rule="evenodd" d="M3.86096 5.91222L9.9765 5.90856L10.5429 4.86226L5.75301 4.86526L6.32334 3.81131L11.1136 3.80831L11.6801 2.76202L6.88979 2.76501L7.46045 1.71107L12.2507 1.7084L12.8168 0.662109L6.70162 0.665769L3.86096 5.91222Z" />
        <path fill-rule="evenodd" clip-rule="evenodd" d="M3.00005 17.99L6.00171 12.4512L5.40357 11.4242L3.05275 15.7627L2.44976 14.7284L4.80091 10.3898L4.20246 9.36285L1.85163 13.7014L1.24897 12.6671L3.60012 8.32854L3.00166 7.30187L0 12.8404L3.00005 17.99Z" />
        <path fill-rule="evenodd" clip-rule="evenodd" d="M23.9999 7.64875L20.9979 13.1879L21.5964 14.2146L23.9476 9.87607L24.5502 10.9107L22.1991 15.2493L22.7972 16.2759L25.1487 11.9377L25.751 12.972L23.4002 17.3106L23.9983 18.3372L27 12.7984L23.9999 7.64875Z" />
        <path fill-rule="evenodd" clip-rule="evenodd" d="M13.2161 13.6018L12.6497 14.6478L15.0849 19.139L14.5136 20.1946L12.0787 15.7037L11.5122 16.7497L13.9471 21.2409L13.3775 22.2925L10.9426 17.8019L10.3758 18.8479L13.3784 24.3854L16.2188 19.1397L13.2161 13.6018Z" />
        <path fill-rule="evenodd" clip-rule="evenodd" d="M12.5947 12.9934L11.4401 12.9941L8.87231 17.4052L7.7074 17.4058L10.2749 12.9951L9.11997 12.9961L6.55251 17.4068L5.39115 17.4075L7.95861 12.9971L6.80372 12.9978L3.63812 18.4365L9.42906 18.4318L12.5947 12.9934Z" />
        <path fill-rule="evenodd" clip-rule="evenodd" d="M13.0573 12.0103L12.4556 10.9856L7.49591 11.0036L6.88872 9.96994L11.8477 9.95231L11.246 8.92764L6.28671 8.9456L5.68114 7.91561L10.6405 7.89731L10.0385 6.87331L3.92328 6.89527L6.94239 12.0322L13.0573 12.0103Z" />
        <path fill-rule="evenodd" clip-rule="evenodd" d="M14.0969 13.6059L14.6986 14.6306L19.6582 14.6126L20.2657 15.6459L15.3064 15.6639L15.9084 16.6882L20.8674 16.6706L21.473 17.7009L16.5136 17.7186L17.1153 18.7429L23.2305 18.7209L20.2121 13.584L14.0969 13.6059Z" />
        <path fill-rule="evenodd" clip-rule="evenodd" d="M14.3647 12.5839L15.5193 12.5833L18.0871 8.17219L19.252 8.17152L16.6845 12.5819L17.8394 12.5809L20.4069 8.17053L21.5682 8.16953L19.0008 12.5799L20.1556 12.5796L23.3212 7.14087L17.5303 7.14519L14.3647 12.5839Z" />
        <path fill-rule="evenodd" clip-rule="evenodd" d="M13.8634 11.6919L14.4299 10.6459L11.9946 6.15433L12.5663 5.09906L15.0012 9.58996L15.5676 8.544L13.1327 4.05276L13.7021 3.00082L16.1373 7.49172L16.7037 6.44576L13.7011 0.907898L10.8608 6.154L13.8634 11.6919Z" />
      </symbol>

      <symbol id="ico-linkedin-in" viewBox="0 0 20 20">
        <path d="M4.29688 20V7.15234H0.300781V20H4.29688ZM2.27734 5.43359C3.56641 5.43359 4.59766 4.35938 4.59766 3.07031C4.59766 1.82422 3.56641 0.792969 2.27734 0.792969C1.03125 0.792969 0 1.82422 0 3.07031C0 4.35938 1.03125 5.43359 2.27734 5.43359ZM19.207 20H19.25V12.9531C19.25 9.51562 18.4766 6.85156 14.4375 6.85156C12.5039 6.85156 11.2148 7.92578 10.6562 8.91406H10.6133V7.15234H6.78906V20H10.7852V13.6406C10.7852 11.9648 11.0859 10.375 13.1484 10.375C15.2109 10.375 15.2539 12.2656 15.2539 13.7695V20H19.207Z" stroke-width="0" />
      </symbol>

      <symbol id="ico-long-arrow-left" viewBox="0 0 24 16">
        <path d="M24 7H3.83L9.42 1.41L8 0L0 8L8 16L9.41 14.59L3.83 9H24V7Z" stroke-width="0" />
      </symbol>

      <symbol id="ico-long-arrow-right" viewBox="0 0 24 16">
        <path d="M0 7H20.17L14.58 1.41L16 0L24 8L16 16L14.59 14.59L20.17 9H0V7Z" stroke-width="0" />
      </symbol>

      <symbol id="ico-footer-subs-arrow-right" viewBox="0 0 15 12" fill="none">
        <path d="M11 1L14 6L11 11" stroke-width="1.5" />
        <path d="M14 6H0" stroke-width="1.5"/>
      </symbol>

      <symbol id="ico-checkbox" viewBox="0 0 14 14">
        <rect x="1" y="1" width="12" height="12" rx="3" style="fill: var(--color-rect); stroke: var(--color-rect); -moz-transition: fill 200ms, stroke 200ms;" stroke-width="1.5" />
        <path d="M4 7.5L5.81818 9L9 5" style="stroke: var(--color-check); -moz-transition: stroke 200ms;" stroke-linecap="round" stroke-linejoin="round" fill-opacity="0" />
      </symbol>

      <symbol id="ico-left-double-quotation-mark" viewBox="0 0 105 82">
        <path d="M6.46627 82C2.15542 69.8519 0 57.8049 0 45.8593C0 32.0914 3.69501 21.0568 11.085 12.7556C18.4751 4.25186 29.2522 0 43.4164 0V19.1333C32.5367 19.1333 27.0968 26.0173 27.0968 39.7852V44.3407H46.8035V82H6.46627ZM64.6628 82C60.5572 69.6494 58.5044 57.6025 58.5044 45.8593C58.5044 32.0914 62.0968 21.0568 69.2815 12.7556C76.6716 4.25186 87.4487 0 101.613 0V19.1333C90.9384 19.1333 85.6012 26.0173 85.6012 39.7852V44.3407H105V82H64.6628Z" />
      </symbol>
    </svg>
  </div>
</template>

<script>
  import pageFooter from '@/components/pageFooter.vue'
  import subscriptionSection from '@/components/subscriptionSection'
  import '@/scss/landing/landing.scss'
  // import '@/assets/img-landing/sprite' // if use javascript include the icon will be keep on the other page jump form landing

  // import Swiper core and required components
  import {Navigation, Scrollbar, A11y, EffectFade} from 'swiper';
  import { Swiper, SwiperSlide } from 'swiper/vue';
  import 'swiper/css';
  import 'swiper/css/navigation';
  import 'swiper/css/scrollbar';
  import 'swiper/css/effect-fade';

  import newsItemTopics from "@/components/newsItem/newsItemTopics";
  let env = process.env.VUE_APP_wssBaseUrl
  export default {
    name: 'App',
    components: {
      pageFooter,
      subscriptionSection,
      Swiper,
      SwiperSlide,
      newsItemTopics,
    },
    data() {
      return {
        showMobileNav: false,
        productDropdownStatus: false,
        loading: true,
        freeArticle:[],
        modules: [Navigation, Scrollbar, A11y, EffectFade],
        env,
      }
    },
    computed: {
      userInfo() {
        return this.$store.state.userInfo || {}
      }
    },
    created() {
      this.$http.$get(`/api/article/public/landing-page/free`).then(res=>{
        this.freeArticle = res.slice(0,6)
      }).finally(()=>{this.loading = false})

      // add script only landing
      let script1 = document.createElement('script')
      script1.setAttribute('src','https://cdn.cookielaw.org/scripttemplates/otSDKStub.js')
      script1.setAttribute('type','text/javascript')
      script1.setAttribute('charset','UTF-8')
      script1.setAttribute('data-domain-script',this.env==='www.navlindaily.com'?'53b7d9e7-160e-44cd-afab-20cb8cf803fa':'53b7d9e7-160e-44cd-afab-20cb8cf803fa-test')
      this.$nextTick(()=>{
        if(this.$refs['landing']){
          this.$refs['landing'].append(script1)
          window.OptanonWrapper = ()=>{ }
        }
      })
    },
    mounted() {
      // let self = this
    },
    beforeUnmount() {
    },
    methods: {
      jumpToNews(){
        document.querySelector('#news-location').scrollIntoView()
      },
      handleProductVisible(val){
        this.productDropdownStatus=val
      },
      showPrev() {
        this.$refs['sliderEl'] && this.$refs['sliderEl'].value.prev()
      },
      showNext() {
        this.$refs['sliderEl'] && this.$refs['sliderEl'].value.next()
      }
    },
  }
</script>

<style lang="scss" scoped>
  @media (max-width: 1023px) {
    .landing{
      [aria-label="Side Panel"] nav{
        margin-right: 0;
      }
      [aria-label="Site"] > ul {
        padding: 0;
        li{
          &:before{
            content: unset;
          }
        }
        a{
          color: #fff;
          height: 42px;
          display: flex;
          border-radius: 4px;
        }
      }
    }
  }

</style>
